/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import {ExdsButton, ExdsGrid, ExdsLayout} from '@exds/core';
import './NotFound.scss';
import React, {useContext, useEffect} from 'react';
import {addPageLoadEvent} from "../AdobeAnalytics/AdobeAnalytics";
import AppContext from "../../AppContext";

export default function NotFound() {
  const {loadAA} = useContext(AppContext);

  useEffect(() => {
    if(loadAA) {
      const pageName = 'Not Found';
      addPageLoadEvent(pageName);
    }
  }, [loadAA]);

  useEffect(() => {
    const appContainer = document.querySelector('.app-container');
    if(appContainer) {
      appContainer.classList.add('hide-border');
    }
  }, []);


  const handleClick = () => {
    window.location.href = "/";
  };

  return (
    <ExdsGrid className='notfound-container'>
      <ExdsLayout
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        className='notfound-content'
      >
        <ExdsLayout
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="stretch"
          className='notfound-text-container'
        >
          <div className="notfound-title">
            We’re sorry!
          </div>
          <div className="notfound-message">
            The page you’re looking for may have been moved or deleted.
          </div>
          <ExdsButton
            variant="tertiary"
            minWidth="208px"
            type="button"
            className="error-button"
            text="Home"
            onClick={handleClick}
          />
        </ExdsLayout>
        <div className="notfound-code">
          404
        </div>
      </ExdsLayout>
    </ExdsGrid>
  );
}
